export default class HeightMatch {
  constructor () {
    this.init()
  }

  init() {
    this.getParam()
    this.bindEvent()
  }

  getParam() {
    this.heightContainer = document.querySelectorAll(`[data-height="heightAdjust"]`)
    this.heightContainerArray = Array.prototype.slice.call(this.heightContainer)
  }

  bindEvent () {

    var mql = window.matchMedia('(min-width: 768px)');

    const Event =(e)=> {
      if (e.matches) {
        Array.prototype.forEach.call(this.heightContainerArray,(elem)=> {
          const
            getHeight = elem.querySelector(`[data-height="heightGet"]`),
            setHeight = elem.querySelector(`[data-height="heightSet"]`)
          let
            getHeigthNum = getHeight.clientHeight
        
          setHeight.style.height = getHeigthNum +'px'
        })            
        /* the viewport is 600 pixels wide or less */
      } else {
        const
          setHeight = document.querySelector(`[data-height="heightSet"]`)        
        setHeight.style.height = 'auto'
        
        /* the viewport is more than than 600 pixels wide */
      }
    }
    
    mql.addListener(Event);
    Event(mql)    


    
  }
}